module.exports = __webpack_public_path__ + "img/5.55f42301.jpg";